var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "+_vm._s(_vm.description)+" "),_c('b-list-group',{staticClass:"mt-2"},_vm._l((_vm.examples),function(example){return _c('b-list-group-item',{key:example,attrs:{"variant":"dark"}},[_vm._v(" "+_vm._s(example)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }